import React  from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from 'react-router-dom';
import LoginContainer from './containers/LoginContainer';
import DashboardContainer from './containers/DashboardContainer';
import PageNotFoundComponent from './components/PageNotFoundComponent';
import ResetPasswordComponent from "./components/ResetPasswordComponent";
import './App.css';
import PaymentSuccessfulComponent from "./components/PaymentSuccessfulComponent";
import WelcomeContainer from "./containers/WelcomeContainer";
import AuthComponent from "./components/AuthComponent";
import {withUser} from "./components/utils/AuthHOC";
import LogoutContainer from "./containers/LogoutContainer";
import ResetPasswordContainer from "./containers/ResetPasswordContainer";

const App = () => (
    <Router history="">
        <div className="content">
            <Switch>
                <Route path="/" exact render={(props)=> <Redirect to="/dashboard/enrollees" /> } />
                <Route component={LoginContainer} path="/login" exact />
                <Route component={ResetPasswordContainer} path="/reset-password" exact/>
                <Route component={withUser(WelcomeContainer)} path="/welcome" exact/>
                <Route component={PaymentSuccessfulComponent} path="/payment-successful" exact />
                <Route component={ResetPasswordComponent} path="/reset-password"/>
                <Route component={AuthComponent} path="/auth" exact />
                <Route component={LogoutContainer} path="/logout" exact />
                <Route component={withUser(DashboardContainer)} path="/dashboard" />
                <Route component={PageNotFoundComponent}/>
            </Switch>
        </div>
    </Router>
);

export default App;
